import type { IconSvgObject } from './types';

const SdCardIcon: IconSvgObject = [
  ["path", { d: "M16.5 5.5V8.5M13 5.5V8.5M9.5 5.5V8.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M5.5 4V9.69722C5.5 9.89465 5.44156 10.0877 5.33205 10.2519L3.8359 12.4962C3.61688 12.8247 3.5 13.2107 3.5 13.6056V20C3.5 21.1046 4.39543 22 5.5 22H18.5C19.6046 22 20.5 21.1046 20.5 20V4C20.5 2.89543 19.6046 2 18.5 2H7.5C6.39543 2 5.5 2.89543 5.5 4Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default SdCardIcon;
